import React from 'react';
import '../../PrivatePeople3LandingNew/Pages/Home/Header/header.css';
import './EstatePlanning/estimate-planning-book.css';
import keysLogoImage from '../../PrivatePeople3LandingNew/assest/images/logo.png';
import { Button, Col, Container, Navbar, Row } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import List from '@material-ui/core/List';
import MenuIcon from '@material-ui/icons/Menu';
import ListItem from '@material-ui/core/ListItem';
import CloseIcon from '@mui/icons-material/Close';
import ListItemText from '@material-ui/core/ListItemText';
import Drawer from '@material-ui/core/Drawer';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles({
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
});

const Header = () => {
    const history = useHistory();
    const classes = useStyles();
    const anchor = 'right';
    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const list = (anchor) => (
        <div
            className={clsx(classes.list, {
                [classes.fullList]: anchor === 'top' || anchor === 'bottom',
            })}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <List className="mobile_menu">
                <div className='header_logo d-flex gap-2'>
                    <Link to='/book'>
                        <img
                            src={keysLogoImage}
                            className="d-inline-block align-top"
                            alt="logo"
                        />
                    </Link>
                    <CloseIcon />
                </div>
                <Link to="/book">
                    <ListItem button key={'text'} className="flex-wrap">
                        <ListItemText to="/webBook/home_book" className="btn">Home</ListItemText>
                    </ListItem>
                </Link>
                <Link to="/shop_book">
                    <ListItem button key={'text'} className="flex-wrap">
                        <ListItemText to="/webBook/shop_book" className="btn">Shop</ListItemText>
                    </ListItem>
                </Link>
                <Link to="/about_book">
                    <ListItem button key={'text'} className="flex-wrap">
                        <ListItemText to="/webBook/about_book" className="btn">About</ListItemText>
                    </ListItem>
                </Link>
                <Link to="/contact_book">
                    <ListItem button key={'text'} className="flex-wrap">
                        <ListItemText to="/webBook/contact_book" className="btn">Contact</ListItemText>
                    </ListItem>
                </Link>
                <Link to="/new-signup">
                    <ListItem button key={'text'} className="flex-wrap">
                        <ListItemText to="/new-signup" className="btn Landing_signup_btn">Sign Up</ListItemText>
                    </ListItem>
                </Link>
                <Link to="/new-login">
                    <ListItem button key={'text'} className="flex-wrap">
                        <ListItemText to="/new-login" className="btn Landing_login_btn">Login</ListItemText>
                    </ListItem>
                </Link>
            </List>
        </div>
    );

    return (
        <>
            <div className='introduction_section home_book_section'>
                <Navbar className='main-header webcopy_main_header'>
                    <Navbar.Brand>
                        <Link to='/book'>
                            <img
                                src={keysLogoImage}
                                className="d-inline-block align-top"
                                alt="logo"
                                style={{ width: "221px" }}
                            />
                        </Link>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                    <Navbar.Collapse expand="md" className="justify-content-end">
                        <ul className='main_menu_list'>
                            <li className='menu_item active'>
                                <Link to="/book">Home</Link>
                            </li>
                            <li className='menu_item'>
                                <Link to="/shop_book">Shop</Link>
                            </li>
                            <li className='menu_item'>
                                <Link to="/about_book">About</Link>
                            </li>
                            <li className='menu_item'>
                                <Link to="/contact_book">Contact</Link>
                            </li>
                        </ul>
                        <div className='header_menu_button'>
                            <Button variant="" className='header_menu_outlinebtn' onClick={() => history.push('/new-login')}>Login</Button>
                            <Button variant="" className='header_menu_btn ml-2' onClick={() => history.push('/new-signup')}>
                                Start Your Free 14-Day Trial
                            </Button>
                        </div>
                    </Navbar.Collapse>
                    <div className="menu_bar">
                        <MenuIcon onClick={toggleDrawer(anchor, true)} />
                    </div>
                </Navbar>
                <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
                    {list(anchor)}
                </Drawer>
                <section className='home_section'>
                    <Container fluid >
                        <div className='inroduction_details '>
                            <Row className='align-items-center justify-content-center m-0'>
                                <Col xl={12}>
                                    <div className='inroduction_heading'>
                                        <h6>
                                            Live out your retirement with <span>peace of mind. </span>
                                            Store <br/> all your end-of-life information in one place with a <br/>
                                            KeysToMyWishes Personal Affairs Organizer
                                        </h6>
                                    </div>
                                    {/*<div className='d-flex justify-content-xl-center justify-content-center  gap-2'>*/}
                                    {/*    <div className='inroduction_details_btn mb-0'>*/}
                                    {/*        <Button variant="" className='button_primary' onClick={() => history.push("/new-signup")}>*/}
                                    {/*            Start Your Free 14-Day Trial*/}
                                    {/*        </Button>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </section>
            </div>
        </>
    )
};
export default Header;